var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section_wrap"},[_c('h6',{staticClass:"--blue70"},[_vm._v("\n      "+_vm._s(_vm.$t('report.components.no_select.name'))+"\n    ")]),_c('div',{staticClass:"section_body"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t('report.components.no_select.context'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }